<template>
  <div class="list errCheck">
    <div class="auctionRegister">
      <h1 class="topTitle">定型文管理</h1>
      <div class="container">
        
        <div class="">
        
          <div>
            <label>
              いいねがついた時のコメント
              <textarea rows="5" v-model="item.IINE"></textarea>
            </label>
          </div>
          <div>
            <label>
              売れた時のコメント
              <textarea rows="5" v-model="item.SELLED"></textarea>
           </label>
          </div>
           <button class="btn repage" @click="update">登録する</button>
        </div>
      <div class="btnBox subArea">
        <button class="btn repage" @click="returnPage">戻る</button>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import { fixed_phrase_repository  } from "@/Repositories/u013_r_fixed_phrase_repository.js";
export default {
  data() {
    return {
      /******************
       * ユーザー情報
       ******************/
      userInfo: {},
      userList: [],
      setUserId: "",
      tmpSiteType: null,
      /******************
       * 登録情報
       ******************/
      item:{},
    };
  },
  methods: {
    returnPage() {
      let vm = this;
      vm.$router.back();
    },

    update(){
      let vm = this;
      fixed_phrase_repository.upd(vm.item).then(res=>{
          this.$swal({
              title: "登録が完了しました",
              icon: "success",
          })
      })
    }
  },
  created: function () {
    let vm = this;
    vm.userInfo = vm.$functions.getSStorage("userInfo");
    fixed_phrase_repository.get(vm.userInfo.USER_ID)
      .then((res) => {
        if(!res.data) vm.item = {};
        else vm.item = res.data;
        vm.item.USER_ID = vm.userInfo.USER_ID;
      })
      .catch((err) => {
        console.log(err);
        //エラーメッセージ表示させるように修正必要
      });
  },
};
</script>

<style lang="scss">
@import "../style/errCheck.scss";
@import "../style/auctionRegister.scss";
label{
  font-weight: bold;
}
</style>